import PropTypes from 'prop-types';
import React from 'react';

import messages from './messages';
import Form from '../../../../components/Form';

import '../styles.css';

const AcademicResidency = ({ onChange, initialValue, formatMessage }) => (
  <div
    styleName="transfer-website-container"
    data-cy="Premium-Hem-Transfer-Academic-Residency-Container"
  >
    <p>{formatMessage(messages.academicResidencyLabel)}</p>
    <Form.Input
      fluid
      min="0"
      type="number"
      value={initialValue.value}
      onChange={(e, { value }) => {
        onChange(e, { value });
      }}
      data-cy="Premium-Hem-Transfer-Academic-Residency-InputField"
    />
  </div>
);

AcademicResidency.propTypes = {
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  initialValue: PropTypes.object,
};
export default AcademicResidency;
